import { UPLOAD_URL } from "../../utils/constants";
import {
  getPrivacyOverlayLabel,
  shouldBlurProfileImage,
} from "../../utils/imagePrivacy";

const BiodataPreview = ({ profile }: any) => {
  if (!profile) return null;
  const calculateAge = (dob: any) => {
    const birthDate = new Date(dob);
    const currentDate = new Date();
    let age = currentDate.getFullYear() - birthDate.getFullYear();
    const month = currentDate.getMonth();
    const day = currentDate.getDate();
    if (
      month < birthDate.getMonth() ||
      (month === birthDate.getMonth() && day < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const blurPhoto = shouldBlurProfileImage(profile.imagePrivacy);
  const renderRow = (label: string, value: unknown) => {
    if (value === null || value === undefined || value === "") return null;
    if (typeof value === "number" && value <= 0) return null;
    if (typeof value === "string" && !value.trim()) return null;

    return (
      <div>
        <b>{label}:</b> {String(value)}
      </div>
    );
  };

  return (
    <div
      style={{
        width: 700,
        padding: 32,
        background: "#fff",
        color: "#222",
        fontFamily: "sans-serif",
        borderRadius: 16,
        boxShadow: "0 2px 12px #0002",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", marginBottom: 24 }}>
        <div style={{ position: "relative", marginRight: 24 }}>
          <img
            src={
              profile.image
                ? `${UPLOAD_URL}/users/profile_pic/${profile.image}`
                : "https://www.pngitem.com/pimgs/m/581-5813504_avatar-dummy-png-transparent-png.png"
            }
            alt="Profile"
            style={{
              width: 100,
              height: 100,
              borderRadius: "50%",
              objectFit: "cover",
              filter: blurPhoto ? "blur(12px)" : undefined,
              transform: blurPhoto ? "scale(1.05)" : undefined,
            }}
          />
          
        </div>
        <div>
          <div style={{ fontWeight: 700, fontSize: 28 }}>
            {profile.fullName || "No Name"}
          </div>
          <div style={{ fontSize: 16, margin: "4px 0" }}>
            Martial ID: <b>{profile.martialId || "N/A"}</b>
          </div>
          <div style={{ fontSize: 16, margin: "4px 0" }}>
            Age:{" "}
            <b>
              {profile.dateOfBirth ? calculateAge(profile.dateOfBirth) : "N/A"}
            </b>
          </div>
          <div style={{ fontSize: 16, margin: "4px 0" }}>
            Gender: <b>{profile.gender || "N/A"}</b>
          </div>
        </div>
      </div>
      <hr style={{ margin: "16px 0" }} />
      <div style={{ display: "flex", gap: 32 }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600, fontSize: 20, marginBottom: 8 }}>
            Personal Details
          </div>
          <div>
            <b>Date of Birth:</b>{" "}
            {profile.dateOfBirth
              ? new Date(profile.dateOfBirth).toLocaleDateString()
              : "N/A"}
          </div>
          <div>
            <b>Birth Time:</b> {profile.time || "N/A"}
          </div>
          <div>
            <b>Marital Status:</b> {profile.maritalStatus || "N/A"}
          </div>
          <div>
            <b>Physical State:</b> {profile.physicalState || "N/A"}
          </div>
          <div>
            <b>Education:</b> {profile.education || "N/A"}
          </div>
          <div>
            <b>Employment Status:</b> {profile.employmentStatus || "N/A"}
          </div>
          <div>
            <b>Occupation:</b> {profile.occupation || "N/A"}
          </div>
          <div>
            <b>Annual Income:</b>{" "}
            {profile.annualIncome ? `₹${profile.annualIncome}` : "N/A"}
          </div>
          <div>
            <b>Location:</b>{" "}
            {[profile.country, profile.state, profile.district]
              .filter(Boolean)
              .join(", ") || "N/A"}
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600, fontSize: 20, marginBottom: 8 }}>
            Family Details
          </div>
          {renderRow("Family Type", profile.familyType)}
          {renderRow("Family Value", profile.familyValue)}
          {renderRow("Father Employee", profile.fatherEmployee)}
          {renderRow("Father Occupation", profile.fatherOccupied)}
          {renderRow("Mother Employee", profile.motherEmployee)}
          {renderRow("Mother Occupation", profile.motherOccupied)}
          {renderRow("Total Brothers", profile.totalBrothers)}
          {renderRow("Married Brothers", profile.marriedBrothers)}
          {renderRow("Total Sisters", profile.totalSisters)}
          {renderRow("Married Sisters", profile.marriedSisters)}
        </div>
      </div>
      <hr style={{ margin: "16px 0" }} />
      <div style={{ fontWeight: 600, fontSize: 20, marginBottom: 8 }}>
        Religion and Caste
      </div>
      <div>
        <b>Religion:</b> {profile.religion || "N/A"}
      </div>
      <div>
        <b>Caste:</b> {profile.caste || "N/A"}
      </div>
      <div>
        <b>Sub Caste:</b> {profile.subcaste || "N/A"}
      </div>
      <div style={{ fontWeight: 600, fontSize: 20, margin: "16px 0 8px" }}>
        Contact
      </div>
      <div>
        <b>Mobile Number:</b> {profile.mobileNumber || "N/A"}
      </div>
      <div>
        <b>Email:</b> {profile.email || "N/A"}
      </div>
    </div>
  );
};

export default BiodataPreview
